
























































































































































import Vue from 'vue';
import AntiAirCalculator from '@/components/result/AntiAirCalculator.vue';
import ContactRates from '@/components/result/ContactRates.vue';
import EnemyFleet from '@/classes/enemy/enemyFleet';
import EnemyInput from './EnemyInput.vue';

export default Vue.extend({
  components: {
    EnemyInput,
    AntiAirCalculator,
    ContactRates,
  },
  name: 'EnemyDetail',
  props: {
    handleShowItemList: {
      type: Function,
    },
    fleet: {
      type: EnemyFleet,
      required: true,
    },
    handleClose: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    tab: 'stage2',
  }),
  mounted() {
    const contact = this.$refs.contactRates as InstanceType<typeof ContactRates>;
    if (contact) {
      contact.calculate();
    }
    const antiAirCalculator = this.$refs.antiAirCalculator as InstanceType<typeof AntiAirCalculator>;
    if (antiAirCalculator) {
      antiAirCalculator.updateTable();
    }
  },
  methods: {
    showItemList(enemyIndex: number, slotIndex: number): void {
      // 敵の装備変更
      this.handleShowItemList(enemyIndex, slotIndex);
    },
    close() {
      this.handleClose();
    },
  },
});
